//
// ***** DO NOT INSTANTIATE THIS CLASS DIRECTLY *****
//
import { autoinject } from 'aurelia-framework';
import { ServiceResponse } from '../models/service-response';
import { Logger } from './logger';
import { JsonSerializer } from '../helpers/json-serializer';

@autoinject
export class BaseService {
	constructor(protected logger: Logger, protected serializer: JsonSerializer) {
	}

	protected success(successMessage: string = '', value: any = null): Promise<ServiceResponse> {
		return new Promise<ServiceResponse>((resolve) => {
			resolve(new ServiceResponse({ isSuccessful: true, resultMessage: successMessage, value: value }));
		});
	}

	protected error(errorMessage: string = ''): Promise<ServiceResponse> {
		return new Promise<ServiceResponse>((resolve) => {
			resolve(new ServiceResponse({ isSuccessful: false, resultMessage: errorMessage, value: null }));
		});
	}

	protected setInStorage(key: string, value: any): void {
		let storageKey: string = this.serviceName + key;
		sessionStorage.setItem(storageKey, this.serializer.serialize(value));
	}

	protected getFromStorage<T>(key: string, type: any): T {
		let storageKey: string = this.serviceName + key;
		let state = sessionStorage.getItem(storageKey);
		if (state) {
			return this.serializer.deserialize<T>(type, sessionStorage.getItem(storageKey));
		}
		return null;
	}

	// prefix the key with the service name when persisting data so if multiple services want
	// to store a variable with the same key, there won't be any collisions
	private get serviceName(): string {
		return this.constructor.name;
	}
}
